import { logInfo } from '@core/logging';
import { supportedThemes } from './themes/manifest';
/**
 * asynchronously loads all given theme scripts
 * and calls their default exported function
 */
async function loadScripts(scripts) {
    for (const s in scripts) {
        const module = await import(`./themes/${scripts[s]}`);
        module.default();
    }
}
/**
 * Tries to integrate with the given Shopify theme by lazy loading
 * a function which attaches and handles the necessary event handlers
 */
export async function integrateWithTheme(theme) {
    if (!theme) {
        logInfo('No theme provided');
        return;
    }
    if (supportedThemes[theme.schema_name]) {
        if (supportedThemes[theme.schema_name][theme.schema_version]) {
            logInfo(`Integrating with ${theme.schema_name} ${theme.schema_version}`);
            await loadScripts(supportedThemes[theme.schema_name][theme.schema_version]);
        }
        else if (supportedThemes[theme.schema_name].default) {
            logInfo(`Integrating with ${theme.schema_name} default`);
            loadScripts(supportedThemes[theme.schema_name].default);
        }
    }
    else {
        logInfo(`Shopify theme "${theme.schema_name}" is not automatically supported by Firework Embeds. Please visit https://docs.firework.com/firework-for-developers/web/integration-guide/shopping-integration-v2/ for more information on how to integrate your Firework Embed with this theme.`);
    }
}
